// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let MediaCard = require("../../common/Components/MediaCard.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let DevelopmentProjectSearchResultCard_developmentProject_graphql = require("../../../__generated__/DevelopmentProjectSearchResultCard_developmentProject_graphql.bs.js");

let getConnectionNodes = DevelopmentProjectSearchResultCard_developmentProject_graphql.Utils.getConnectionNodes;

let convertFragment = DevelopmentProjectSearchResultCard_developmentProject_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, DevelopmentProjectSearchResultCard_developmentProject_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(DevelopmentProjectSearchResultCard_developmentProject_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, DevelopmentProjectSearchResultCard_developmentProject_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(DevelopmentProjectSearchResultCard_developmentProject_graphql.node, convertFragment, fRef);
}

let ProjectFragment = {
  getConnectionNodes: getConnectionNodes,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function DevelopmentProjectSearchResultCard(props) {
  let project = RescriptRelay_Fragment.useFragment(DevelopmentProjectSearchResultCard_developmentProject_graphql.node, convertFragment, props.project);
  let image = getConnectionNodes(project.projectImages)[0];
  return JsxRuntime.jsx(MediaCard.make, {
    topLeftLabels: props.label,
    mediaLink: `/developments/` + project.id,
    media: image !== undefined ? ({
        TAG: "Image",
        _0: {
          src: image.url,
          width: 648,
          height: 468,
          alt: ""
        }
      }) : ({
        TAG: "Icon",
        _0: "home"
      }),
    children: props.children
  });
}

let make = DevelopmentProjectSearchResultCard;

exports.ProjectFragment = ProjectFragment;
exports.make = make;
/* MediaCard Not a pure module */
